import { PaginationQueryDto } from './common/dtos/pagination/pagination.query.dto';

export const INSTITUTION_FILTER_STORAGE = 'INSTITUTION_FILTERS';
export const DEFAULT_PAGINATION_QUERY: PaginationQueryDto = {
  page: '1',
  take: '10',
  sortBy: 'created_at',
  orderBy: 'DESC',
};
